// create_investor_zone
export const CREATE_INVESTOR_ZONE = 'create_investor_zone';
export const CREATE_INVESTOR_ZONE_SUCCESSFUL =
  'create_investor_zone_successfull';
export const CREATE_INVESTOR_ZONE_FAILED = 'create_investor_zone_failed';

// get_investor_zones
export const GET_INVESTOR_ZONES = 'get_investor_zones';
export const GET_INVESTOR_ZONES_SUCCESSFUL = 'get_investor_zones_successfull';
export const GET_INVESTOR_ZONES_FAILED = 'get_investor_zones_failed';

// delete_investor_zone
export const DELETE_INVESTOR_ZONE = 'delete_investor_zone';
export const DELETE_INVESTOR_ZONE_SUCCESSFUL =
  'delete_investor_zone_successfull';
export const DELETE_INVESTOR_ZONE_FAILED = 'delete_investor_zone_failed';

// update_investor_zone
export const UPDATE_INVESTOR_ZONE = 'update_investor_zone';
export const UPDATE_INVESTOR_ZONE_SUCCESSFUL =
  'update_investor_zone_successfull';
export const UPDATE_INVESTOR_ZONE_FAILED = 'update_investor_zone_failed';
